import {Sort} from '../../utils/url.builder';

export class Pageable {

    pageNumber: number;
    pageSize: number;
    sort: Sort;

    private constructor(page: number, size: number, sort: Sort) {
        this.pageNumber = page;
        this.pageSize = size;
        this.sort = sort;
    }
    public withSort(sort: Sort): Pageable {
        return new Pageable(this.pageNumber, this.pageSize, sort);
    }

    static of(page: number, size: number): Pageable{
        return new Pageable(page, size, undefined);
    }

    static ofFirstPage(size: number): Pageable {
        return new Pageable(0, size, undefined);
    }

    static ofWithSort(page: number, size: number, sort: Sort): Pageable {
        return new Pageable(page, size, sort);
    }

    static ofDefault(): Pageable{
        return new Pageable(0, 20, undefined);
    }

    public static equalsPagePageable(obj1: Pageable, obj2: Pageable) : boolean {
        if (!obj1 || !obj2) {
            return false;
        }
        return obj1.pageNumber === obj2.pageNumber && obj1.pageSize === obj2.pageSize;
    }
}
